import { Avatar } from "@mui/material";
import { useState } from "react";
import classes from "./Avatar.module.css"

const BrandAvatar = ({ domainName = "example.com", brandName, className }) => {
  const [imgError, setImgError] = useState(false);

  const getBrandInitial = (name) =>
    name ? name.charAt(0).toUpperCase() : "?";

  const isValidDomain = (domain) => {
    if (!domain || domain === "example.com") return false;
    return true;
  };

  const getLogoUrl = (domain) => {
    if (!isValidDomain(domain)) return null;
    
    const cleanDomain = domain
      .replace(/^(https?:\/\/)?(www\.)?/, "")
      .split("/")[0];

    return `https://img.logo.dev/${cleanDomain}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`;
  };

  const logoUrl = getLogoUrl(domainName);
  const shouldShowImage = logoUrl && !imgError;

  return (
    <Avatar
      className={classes.brandAvatar}
      src={shouldShowImage ? logoUrl : undefined}
      imgProps={{ referrerPolicy: "no-referrer" }}
      onError={() => setImgError(true)}
      sx={{
        bgcolor: shouldShowImage
          ? "transparent"
          : `hsl(${(brandName?.charCodeAt(0) || 0) * 10}, 60%, 70%)`,
      }}
    >
      {!shouldShowImage && getBrandInitial(brandName)}
    </Avatar>
  );
};

export default BrandAvatar;